(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ww-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ww-size-guide')) {
  customElements.define('ww-size-guide', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const dialog = this.querySelector('dialog');
      const trigger = this.querySelector('.ww-size-guide__link');
      if (!dialog || !trigger || typeof dialog.showModal !== 'function') return;
      const options = { signal: this.controller.signal };
      trigger.addEventListener('click', event => {
        event.preventDefault();
        if (!dialog.open) dialog.showModal();
      }, options);
      this.querySelector('[data-ww-size-close]').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }, options);
    }
    disconnectedCallback() {
      this.querySelector('dialog')?.close();
      this.controller?.abort();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
